<template>
<!-- :class="{'menu-active': menuActive}" -->
  <div id="main-id" ref="main-id" :class="['main', activePanel]">
      <div class="row inherit">
        <!--[if lt IE 10]>
          <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
        <![endif]-->
        <sidebar></sidebar>
        <router-view :key="$store.state.route.meta.type || $store.state.route.name"></router-view>
      </div>
      <div class="mobile-overlay" @click="hidePanel"></div>
  </div>
</template>

<script>
import $ from 'jquery'
import sidebar from './sidebar'
require('../static/js/jquery.touchwipe.js')

export default {
  name: 'dashboard',
  props: ['affiliate'],
  components: {
    sidebar
  },
  computed: {
    activePanel() {
      return this.$store.state.activePanel + '-active';
    }
  },
  deactivated() {
    if (this.affiliate != this.$store.state.user.affiliate_id) {
      this.$destroy()
    }
  },
  mounted() {
    $(this.$refs['main-id']).touchwipe({
      wipeLeft: this.togglePanel,
      wipeRight: this.togglePanel,
      min_move_y: 99999,
      min_move_x: 60,
      preventDefaultEvents: false
    })
  },
  methods: {
    togglePanel() {
      if (!this.$store.state.activePanel) {
        this.showMenu()
      } else {
        this.hidePanel()
      }
    },
    showMenu(e) {
      if (e && e.stopPropagation)
        e.stopPropagation()
      this.$store.commit('setPanel', this.$store.state.activePanel != 'menu'? 'menu': null)
    },
    hidePanel(e) {
      if (e && e.stopPropagation) 
        e.stopPropagation()
      this.$store.commit('setPanel', null);
    }
  }
};
</script>
<style scoped>
/*====
*
** AURTHOR CUSTOM STYLES
*
====*/

@import url('https://fonts.googleapis.com/css?family=Istok+Web|Questrial|Fjalla+One');

h1, h2, h3, h4, h5 {
    font-family: 'Istok Web', Helvetica, sans-serif;
}
h1 {
    font-size: 24px;
}
h2 {
    font-size: 20px;
}
ul{
    padding: 0;
    margin: 0;
}
ul li{
    list-style-type: none;
    margin-bottom: 0;
}
p{
    font-size: 14px;
    line-height: 18px;
}
.main .inherit{
    height: inherit;
    overflow: hidden;
}
select,
input{
    outline: none;
}
</style>

<style lang="scss">
body,
.row,
.sidebar,
.panels,
.data-holder,
p{
  padding: 0;
  margin: 0;
  font-family: 'Questrial', Arial, sans-serif;
}

.filter select{
    border: none;
    background: transparent;
    color: #909090;
    padding: 12px 0;
    transition: width .3s;
}
.two-col-content{
    height: 100%;
    padding: 0;
    margin: 0;
    width: auto;
    position: relative;
    transition: all .3s;
    overflow: hidden;
}

/*====
*
** Element UI Fixes
*
====*/

* {
  box-sizing: border-box;
}
.el-date-table {
    line-height: 32px;
}
.el-date-table td.today {
    padding: 0px 0 !important;
    font-size: 10px;
}
.el-notification__group {
    margin-left: 60px;
}
.el-notification {
    width: 400px;
}

/*====
*
** HAMBURGER MENU/ACTIVE MENU
*
====*/

.menu-active
{ /*Mennu Active*/
  .sidebar{
    left: 0%;
  }

}
.menu-active .mobile-overlay,
.data-active .mobile-overlay{
  visibility: visible;
  opacity: .3;
}
.data-active .data-holder{
  right: 0;
}
.mobile-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  visibility: hidden;
  opacity: 0;
  transition: visibility .5s, opacity .5s;
  z-index: 5;
}

/*====
*
** FADE IN EFFECT
*
====*/

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/*====
*
** RESPONSIVE
*
====*/

@media(max-width: 767px) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 15px;
  }
}
@media(min-width: 768px){
  .mobile-overlay {
    z-index: 199;
  }
}
@media(min-width: 1024px){
 	.menu-icon{
 		z-index: 261;
 	}
 	#main-id:not(.menu-active) .mobile-overlay{
 		visibility: hidden !important;
 		opacity: 0 !important;
 	}
}
@media(min-width: 1199px){
	.menu-icon{
		display: none;
	}
 	.mobile-overlay{
 		visibility: hidden !important;
 		opacity: 0 !important
 	}
 	.sidebar{
 		left: 0 !important;
 	}
 	.data-active .slidein{
 		right: 0;
 	}
}
</style>



// WEBPACK FOOTER //
// dash.vue?1badcf9e